import React from 'react'
import CartTicketType from './cart-ticket-type'
import { setHitMaximumsWithDependencies } from '../helpers/maximums'
import { buildTickets } from '../../shared/helpers/cart-builder'
import { ProductTable } from './product-table'
import { hitEmployeeMax } from '../helpers/logic'
import {
  hitMembershipMax,
  hitSpecificConstituencyMax
} from '../../shared/helpers/logic'

const getTickets = (pricing, tickets) => {
  const { member, nonMember } = pricing
  const memberTickets = member ? buildTickets(member, tickets) : []
  const nonMemberTickets = nonMember ? buildTickets(nonMember, tickets) : []
  return [...memberTickets, ...nonMemberTickets]
}

function TicketTypes({
  items,
  item,
  dependencies,
  membership,
  remainingTickets
}) {
  const { tickets, pricing } = item
  const maximumsTickets = getTickets(pricing, tickets)
  const maximumsDependencies = dependencies.map(dependency => ({
    ...dependency,
    tickets: getTickets(dependency.pricing, dependency.tickets)
  }))
  const hitMaximumsByAge = setHitMaximumsWithDependencies(
    { ...item, tickets: maximumsTickets },
    maximumsDependencies,
    membership,
    hitEmployeeMax(item, remainingTickets.remainingEmployeeTickets),
    hitMembershipMax(item, remainingTickets.remainingMembershipTickets),
    hitSpecificConstituencyMax(
      item,
      remainingTickets.remainingConstituencyTickets
    )
  )
  const ageSort = [
    'employee',
    'adult',
    'adult2',
    'youth',
    'youth2',
    'child',
    'child2',
    'infant'
  ]

  const rows = tickets
    .sort((a, b) => ageSort.indexOf(a.ageGroup) - ageSort.indexOf(b.ageGroup))
    .map((ticket, index) => {
      return (
        <CartTicketType
          key={`${ticket.priceTypeId}`}
          items={items}
          item={item}
          dependencies={dependencies}
          ticket={ticket}
          ticketIndex={index}
          last={index === tickets.length - 1}
          hitMaximumsByAge={hitMaximumsByAge}
        />
      )
    })

  return <ProductTable>{rows}</ProductTable>
}

export default TicketTypes
